<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    <input class="form-control mr-sm-2"
                           v-model="search.name"
                            type="search"
                            placeholder="ชื่อวัสดุ"
                            aria-label="Search"/>
                    <select class="form-control mr-sm-2 w-25"
                            v-model="search.source_id">
                        <option value="">โปรดเลือกแหล่งที่มา</option>
                        <option value="1">ในประเทศ</option>
                        <option value="2">นอกประเทศ</option>
                    </select>
                    <button class="btn btn-success my-2 my-sm-0"
                            type="button"
                            @click="searchFactorialMaterial">
                        <icon name="search"></icon> ค้นหา
                    </button>&nbsp;&nbsp;
                    <router-link to="/factorial-material-information">
                        <button
                                class="btn btn-warning my-2 my-sm-0"
                                type="button">
                            <icon name="plus"></icon>
                            เพิ่มวัสดุอุปกรณ์โรงงาน
                        </button>
                    </router-link>
                </form>
            </div>
        </nav>
        <div class="table-responsive">
            <table class="table table-bordered">
                <thead>
                <tr>
                    <th>นำเข้าวัสดุ</th>
                    <th>เบิกวัสดุ</th>
                    <th>ชื่อวัสดุ</th>
                    <th>แหล่งที่มา</th>
                    <th>จำนวนคงเหลือ</th>
                    <th>วันที่อัพเดตล่าสุด</th>
                    <th>แก้ไข</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in factorialMaterialList">
                    <td>
                        <a @click="showFactorialMaterialImportModal(data.id)">
                            <img src="@/assets/plus_icon.png" width="40px"/>
                        </a>
                    </td>
                    <td>
                        <a @click="showFactorialMaterialExportModal(data.id)">
                            <img src="@/assets/delete_icon.png" width="40px"/>
                        </a>
                    </td>
                    <td>
                        <template v-if="data.name">
                            {{data.name}}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.source_id">
                            <template v-if="data.source_id == 1">
                                ในประเทศ
                            </template>
                            <template v-else>
                                นอกประเทศ
                            </template>
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.quantity || data.quantity == 0">
                            {{data.quantity | amount}}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        {{data.updated_at | moment("DD/MM/YYYY , H:mm:ss")}}
                    </td>
                    <td>
                        <a @click="showFactorialMaterialByID(data.id)">
                            <icon name="pencil-alt"></icon>
                        </a>
                        &nbsp;&nbsp;
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <div v-if="factorialMaterialList.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getFactorialMaterialList">
            </vue-pagination>
        </div>

        <!--b-model--->
        <!--
            -------------------Modal Import Data--------------------------------
        -->
        <b-modal
                hide-footer
                ref="import_data"
                id="import"
                title="เพิ่มวัตถุดิบเข้าคลัง">
            <import-factorial-material-modal @submit="saveFactorialMaterialImport">
            </import-factorial-material-modal>
        </b-modal>
        <!--
            -------------------Modal export Data--------------------------------
        -->
        <b-modal
                hide-footer
                ref="export_data"
                id="export"
                title="เบิกวัตถุดิบ">
            <export-factorial-material-modal @submit="saveFactorialMaterialExport">
            </export-factorial-material-modal>
        </b-modal>
        <br />


<!--        <pre class="alert-primary">{{factorialMaterialList}}</pre>-->
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import VuePagination from "../../Pagination";
    import ImportFactorialMaterialModal from "../ImportFactorial/ImportFactorialMaterialModal";
    import ExportFactorialMaterialModal from "../ExportFactorial/ExportFactorialMaterialModal";
    export default {
        components: {
            ExportFactorialMaterialModal,
            ImportFactorialMaterialModal,
            VuePagination,
        },
        name: "factorial-material-list",
        created(){
            this.$store.dispatch("FactorialMaterial/setFactorialMaterial").then(res=>{
                this.dataPaginate = {
                    current_page : res.current_page,
                    from : res.form,
                    last_page : res.last_page,
                    per_page : res.per_page,
                    total : res.total,
                    to : res.to
                }
                this.factorialMaterialList = res.data;
            });
            this.$store.dispatch("FactorialMaterial/clearFormData");
            this.$store.dispatch("FactorialMaterial/clearSearch");
            this.$store.dispatch("FactorialMaterialImport/clearFormData")
            this.$store.dispatch("FactorialMaterialExport/clearFormData")
        },
        data() {
            return {
                event_submit : false,
                factorialMaterialList : [],
                dataPaginate: {
                    current_page: 1,
                    from: 1,
                    last_page: 1,
                    per_page: 1,
                    total: 1,
                    to: 1
                },
            };
        },
        computed:{
            ...mapState({
                search : state=>{
                    return state.FactorialMaterial.search
                },
            })
        },
        methods:{
            //modal
            showFactorialMaterialImportModal(id) {
                this.showFactorialMaterialData(id);
                this.$refs.import_data.show();
            },
            hideFactorialMaterialImportModal() {
                this.$refs.import_data.hide();
            },
            showFactorialMaterialExportModal(id) {
                this.showFactorialMaterialData(id);
                this.$refs.export_data.show();
            },
            hideFactorialMaterialExportModal() {
                this.$refs.export_data.hide();
            },
            //API
            showFactorialMaterialData(id) {
                this.$store.dispatch("FactorialMaterial/showFactorialMaterialByID", id);
            },
            showFactorialMaterialByID(id){
                this.$store.dispatch("FactorialMaterial/showFactorialMaterialByID",id).then(data=>{
                    this.$router.push("/factorial-material-information")
                });
            },
            getFactorialMaterialList(){
                const page = this.dataPaginate.current_page;
                //paginate search
                if(this.event_submit){

                    let data = {
                        page : page,
                        name : this.search.name,
                        source_id : this.search.source_id
                    };
                    this.$store.dispatch('FactorialMaterial/search',data).then(res=> {
                        this.dataPaginate = {
                            current_page: res.current_page,
                            from: res.form,
                            last_page: res.last_page,
                            per_page: res.per_page,
                            total: res.total,
                            to: res.to
                        }
                        this.factorialMaterialList = res.data;
                    })
                }
                //paginate get data
                else{
                    this.$store.dispatch("FactorialMaterial/setFactorialMaterial",page).then(res=>{
                        this.dataPaginate = {
                            current_page: res.current_page,
                            from: res.form,
                            last_page: res.last_page,
                            per_page: res.per_page,
                            total: res.total,
                            to: res.to
                        }
                        this.factorialMaterialList = res.data;
                    });
                }
            },
            saveFactorialMaterialImport(submitData){
                if(submitData != 0){
                    this.$store.dispatch("FactorialMaterialImport/saveFactorialMaterialImport",submitData).then(()=>{
                        this.$router.push({
                            name: "factorial-material-import"
                        });
                        this.$store.dispatch("FactorialMaterialImport/clearFormData")
                        this.$store.dispatch("FactorialMaterial/setFactorialMaterial").then(res=>{
                            this.dataPaginate = {
                                current_page: res.current_page,
                                from: res.form,
                                last_page: res.last_page,
                                per_page: res.per_page,
                                total: res.total,
                                to: res.to
                            }
                            this.factorialMaterialList = res.data;
                        });
                    })
                }
                this.hideFactorialMaterialImportModal();
            },
            saveFactorialMaterialExport(submitData) {
                if(submitData != 0){
                    this.$store.dispatch("FactorialMaterialExport/saveFactorialMaterialExport",submitData).then(()=>{
                        this.$router.push({
                            name: "factorial-material-export"
                        });
                        this.$store.dispatch("FactorialMaterialExport/clearFormData")
                        this.$store.dispatch("FactorialMaterial/setFactorialMaterial").then(res=>{
                            this.dataPaginate = {
                                current_page: res.current_page,
                                from: res.form,
                                last_page: res.last_page,
                                per_page: res.per_page,
                                total: res.total,
                                to: res.to
                            }
                            this.factorialMaterialList = res.data;
                        });
                    })
                }
                this.hideFactorialMaterialExportModal();
            },
            searchFactorialMaterial(){
                this.event_submit = true;

                this.$store.dispatch('FactorialMaterial/search',this.search).then(res=>{
                    this.dataPaginate = {
                        current_page: res.current_page,
                        from: res.form,
                        last_page: res.last_page,
                        per_page: res.per_page,
                        total: res.total,
                        to: res.to
                    }
                    this.factorialMaterialList = res.data;
                })
            },
        }
    }
</script>

<style scoped>

</style>
